import { render, staticRenderFns } from "./myPrize.vue?vue&type=template&id=4c5b7b00&scoped=true"
import script from "./myPrize.vue?vue&type=script&lang=js"
export * from "./myPrize.vue?vue&type=script&lang=js"
import style0 from "./myPrize.vue?vue&type=style&index=0&id=4c5b7b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b7b00",
  null
  
)

export default component.exports